import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Box, Container, Grid, Paper } from "@mui/material";
import AdminNewSidebar from "components/admin/AdminNewSidebar";
import { Header } from "components";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { Button } from "react-bootstrap";
import useNavigate from "hooks/Navigate";
import { SUB_ADMIN_TYPES } from "assets/constants";
import SignatureSuccessModal from "components/modals/SignatureSuccessModal";
import { DataGrid } from "@mui/x-data-grid";
import AnnualProgressTable from "components/datagrid/AnnualProgressTable";
import apis from "services";
import {
  WalletAction,
  WalletProfit,
  WalletProfits,
} from "components/SVG/SIDEBARSVG";

const mdTheme = createTheme();

const Wallet = () => {
  const navigate = useNavigate();

  const [tab, setTab] = useState("normal");
  const { adminUser } = useSelector((store) => store.admin);
  const { wallet } = useSelector((store) => store.wallet);

  const { user } = useSelector((store) => store.user);
  const walletData = _.get(adminUser, "wallet", { share: 0, balance: 0 });

  const [modal, setModal] = useState(false);
  const reserveWalletData = _.get(adminUser, "reserveWallet", {
    share: 0,
    balance: 0,
  });

  const newWalletData = _.get(adminUser, "newWallet", { share: 0, balance: 0 });
  const { t } = useTranslation();
  const toggleModal = () => {
    setModal((prevState) => !prevState);
  };

  const methods = {
    navigate,
    adminUser,
  };

  const [annualProgress, setAnnualProgress] = useState([]);
  const { rows, columns } = AnnualProgressTable(annualProgress, methods);

  const fetchAllAnnualProgress = async () => {
    const res = await apis.getAllAnnualProgress();
    if (res.data.status) setAnnualProgress(res.data.annualProgress);
  };

  useEffect(() => {
    if (user && user?.isInvestor) {
      fetchAllAnnualProgress();
    }
  }, []);

  return (
    <ThemeProvider theme={mdTheme}>
      <Box className="dashboard-main">
        <AdminNewSidebar />
        <div className="dashboard-section-main">
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              height: "100vh",
              overflow: "auto",
            }}
            className="custom-scroll"
          >
            <div>
              <Header />
              <Container
                sx={{ mt: 4, mb: 4 }}
                // className="adminContainer"
                className="mainContainerComp"
              >
                <div className="flex-with-title">
                  {user?.isKYCCompleted === "completed" && user?.isInvestor && (
                    <button
                      className="primary-btn-profit mx-3 mt-2"
                      onClick={() => toggleModal()}
                    >
                      KYC Contract Download
                    </button>
                  )}
                </div>
                <div className="mt-2 wallet-con" style={{ fontWeight: "500", }}>
                  {t("new-changes.walletId")}
                  <span style={{ marginLeft: "6px", color: "#E0221E" }}>
                    {adminUser ? adminUser?.wallet?._id : wallet?._id}
                  </span>
                </div>

                {adminUser?.type === "owner" ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      flexWrap:"wrap"
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div className="wallet-con" style={{ fontWeight: "500" }}>
                        Reserve Wallet Id
                        <span style={{ marginLeft: "6px", color: "#E0221E" }}>
                          {adminUser?.reserveWallet?._id}
                        </span>
                      </div>
                      <div
                        className="mt-2 wallet-con"
                        style={{ fontWeight: "500" }}
                      >
                        New Wallet Id{" "}
                        <span style={{ marginLeft: "6px", color: "#E0221E" }}>
                          {adminUser?.newWallet?._id}
                        </span>
                      </div>
                    </div>
                    <div className="share-type d-flex flex-wrap">
                      <Button
                        className={
                          tab === "normal" ? "w-10 active_type " : "w-10"
                        }
                        variant="outline-danger"
                        onClick={() => setTab("normal")}
                      >
                        Normal Wallet
                      </Button>
                      <Button
                        className={
                          tab === "reserve" ? "w-10 active_type " : "w-10"
                        }
                        variant="outline-danger"
                        onClick={() => setTab("reserve")}
                      >
                        Reserve Wallet
                      </Button>
                      <Button
                        className={tab === "new" ? "w-10 active_type " : "w-10"}
                        variant="outline-danger"
                        onClick={() => setTab("new")}
                      >
                        New Wallet
                      </Button>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                <Grid
                  container
                  classes="d-flex justify-content-center"
                  className="mt-4 "
                >
                  {adminUser ? (
                    <>
                      {SUB_ADMIN_TYPES.includes(adminUser?.type) && (
                        <div className="wallet-cardd">
                          <div className="dashboard-box">
                            <div className="wallet-flex-container">
                              <div className="dashboard-box-wallet">
                                <h3>{t("labels.wallet_2")}</h3>
                                <h4>{walletData?.shares || 0}</h4>
                              </div>

                              <div className="img-con">
                                <WalletAction />
                              </div>
                            </div>
                          </div>

                          <div className="dashboard-box">
                            <div className="wallet-flex-container">
                              <div className="dashboard-box-wallet">
                                <h3 className="text-center">
                                  {t("labels.balance")}
                                </h3>
                                <h4>${walletData?.balance || 0} </h4>
                              </div>

                              <div className="img-con">
                                <WalletProfits />
                              </div>
                            </div>
                          </div>

                          <div className="dashboard-box">
                            <div className="wallet-flex-container">
                              <div className="dashboard-box-wallet">
                                <h3 className="text-start">
                                  {t("labels.admin_dashboard_5")}
                                </h3>
                                <h4>${walletData?.dividend || 0} </h4>
                              </div>
                              <div className="img-con">
                                <WalletProfit />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {adminUser?.type === "owner" ? (
                        <>
                          {tab === "normal" && (
                            <div className="wallet-cardd">
                              <div className="dashboard-box">
                                <div className="wallet-flex-container">
                                  <div className="dashboard-box-wallet">
                                    <h3 className="text-center">
                                      {t("labels.wallet_2")}
                                    </h3>
                                    <h4>
                                      {adminUser
                                        ? walletData?.shares || 0
                                        : wallet?.shares || 0}{" "}
                                    </h4>
                                  </div>
                                  <div className="img-con">
                                    <WalletAction />
                                  </div>
                                </div>
                              </div>

                              <div className="dashboard-box">
                                <div className="wallet-flex-container">
                                  <div className="dashboard-box-wallet">
                                    <h3 className="text-center">
                                      {t("labels.balance")}
                                    </h3>
                                    <h4>
                                      {adminUser
                                        ? walletData?.balance || 0
                                        : wallet?.shares || 0}{" "}
                                    </h4>
                                  </div>
                                  <div className="img-con">
                                    <WalletProfit />
                                  </div>
                                </div>
                              </div>

                              <div className="dashboard-box">
                                <div className="wallet-flex-container">
                                  <div className="dashboard-box-wallet">
                                    <h3 className="text-start">
                                      {t("labels.admin_dashboard_5")}
                                    </h3>
                                    <h4>
                                      {adminUser
                                        ? walletData?.dividend || 0
                                        : wallet?.shares || 0}
                                    </h4>
                                  </div>
                                  <div className="img-con">
                                    <WalletProfits />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {tab === "reserve" && (
                            <div className="wallet-cardd">
                              <div className="dashboard-box">
                                <div className="wallet-flex-container">
                                  <div className="dashboard-box-wallet">
                                    <h3 className="text-center">
                                      {t("labels.reserveWalletShares")}
                                    </h3>
                                    <h4>{reserveWalletData?.shares}</h4>
                                  </div>
                                  <div className="img-con">
                                    <WalletAction />
                                  </div>
                                </div>
                              </div>

                              <div className="dashboard-box">
                                <div className="wallet-flex-container">
                                  <div className="dashboard-box-wallet">
                                    <h3 className="text-center">
                                      {t("labels.reserveWalletBalance")}
                                    </h3>
                                    <h4>{reserveWalletData?.balance}</h4>
                                  </div>
                                  <div className="img-con">
                                    <WalletProfits />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {tab === "new" && (
                            <div className="wallet-cardd">
                              <div className="dashboard-box">
                                <div className="wallet-flex-container">
                                  <div className="dashboard-box-wallet">
                                    <h3 className="text-center">
                                      {t("labels.newWalletShares")}
                                    </h3>
                                    <h4>{newWalletData?.shares}</h4>
                                  </div>
                                  <div className="img-con">
                                    <WalletAction />
                                  </div>
                                </div>
                              </div>

                              <div className="dashboard-box">
                                <div className="wallet-flex-container">
                                  <div className="dashboard-box-wallet">
                                    <h3 className="text-center">
                                      {t("labels.newWalletBalance")}
                                    </h3>
                                    <h4>{newWalletData?.balance}</h4>
                                  </div>
                                  <div className="img-con">
                                    <WalletProfits />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  ) : (
                    <>
                      <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Paper
                          sx={{
                            p: 2,
                            display: "flex",
                            flexDirection: "column",
                          }}
                          className="dashboard-box"
                        >
                          <h3 className="text-center">
                            {t("labels.wallet_1")}
                          </h3>
                          <h4>${wallet?.amount || 0}</h4>
                        </Paper>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Paper
                          sx={{
                            p: 2,
                            display: "flex",
                            flexDirection: "column",
                          }}
                          className="dashboard-box"
                        >
                          <h3 className="text-center">
                            {t("labels.wallet_2")}
                          </h3>
                          <h4> {wallet?.shares || walletData?.shares || 0}</h4>
                        </Paper>
                      </Grid>

                      <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Paper
                          sx={{
                            p: 2,
                            display: "flex",
                            flexDirection: "column",
                          }}
                          className="dashboard-box"
                        >
                          <h3 className="text-center">
                            {t("labels.dashboard_3")}
                          </h3>
                          <h4>${wallet?.dividend || 0}</h4>
                          <button
                            className="lp-btn-invest p-1 mb-3"
                            onClick={() => navigate(`/franchise`)}
                          >
                            Buy Now
                          </button>
                        </Paper>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Paper
                          sx={{
                            p: 2,
                            display: "flex",
                            flexDirection: "column",
                          }}
                          className="dashboard-box"
                        >
                          <h3 className="text-center">{t("labels.token")}</h3>
                          <h4>{wallet?.jtcToken || 0}</h4>
                        </Paper>
                      </Grid>
                    </>
                  )}
                </Grid>

                {user && user?.isInvestor && (
                  <>
                    <h4 className="dashboard-title mt-4">
                      {t("titles.annual-report")}
                    </h4>
                    <Grid
                      item
                      container
                      justifyContent="flex-end"
                      className="mt-4"
                      sx={{ height: "600px" }}
                    >
                      <DataGrid
                        rows={rows}
                        columns={columns}
                        getRowClassName={(params) =>
                          params.indexRelativeToCurrentPage % 2 === 0
                            ? "even"
                            : "odd"
                        }
                      />
                    </Grid>
                  </>
                )}

                <SignatureSuccessModal
                  toggleModalSuccess={toggleModal}
                  status={modal}
                  userId={user?.id}
                />
                <img
                  src="/assets/images/frameCardBG.png"
                  alt="frameCardBG"
                  style={{
                    position: "absolute",
                    bottom: "-46px",
                    left: "0",
                    width: "296px",
                  }}
                />
              </Container>
            </div>
          </Box>
        </div>
      </Box>
    </ThemeProvider>
  );
};

export default Wallet;
